import {
  CheckCircle2,
  XCircle,
  AlertTriangle,
  Info,
  HelpCircle,
  PartyPopper
} from 'lucide-react'

/**
 * Icon mapping for Swaller types
 * Maps swaller type to lucide-react icon component
 */
export const swallerIcons = {
  success: CheckCircle2,
  error: XCircle,
  warning: AlertTriangle,
  info: Info,
  question: HelpCircle,
  welcome: PartyPopper
}

/**
 * Color mapping for Swaller types
 * Returns color based on type and theme
 */
export const getSwallerColor = (type, theme) => {
  const isDark = theme.name === 'dark'

  const colors = {
    success: '#22c55e',
    error: isDark ? '#EF4444' : '#DC2626',
    warning: isDark ? '#FB923C' : '#EA580C',
    info: isDark ? '#3B82F6' : '#2563EB',
    question: theme.colors.text.primary,
    welcome: '#22c55e' // Same as success
  }

  return colors[type] || theme.colors.text.primary
}
